import { SimplePool, getPublicKey, nip19, generateSecretKey } from "nostr-tools";
import { SendNofferRequest } from "./noffer.js";
import { SendNdebitRequest } from "./ndebit.js";
import { SendNmanageRequest } from "./nmanage.js";
export class ClinkSDK {
    constructor(settings, pool) {
        this.Noffer = (data, onReceipt, timeoutSeconds) => {
            return SendNofferRequest(this.pool, this.settings.privateKey, this.settings.relays, this.settings.toPubKey, data, timeoutSeconds || this.settings.defaultTimeoutSeconds, onReceipt);
        };
        this.Ndebit = (data, timeoutSeconds) => {
            return SendNdebitRequest(this.pool, this.settings.privateKey, this.settings.relays, this.settings.toPubKey, data, timeoutSeconds || this.settings.defaultTimeoutSeconds);
        };
        this.Nmanage = (data, timeoutSeconds) => {
            return SendNmanageRequest(this.pool, this.settings.privateKey, this.settings.relays, this.settings.toPubKey, data, timeoutSeconds || this.settings.defaultTimeoutSeconds);
        };
        this.settings = settings;
        if (pool) {
            this.pool = pool;
        }
        else {
            this.pool = new SimplePool();
        }
    }
}
export * from './nip19Extension.js';
export * from './noffer.js';
export * from './nmanage.js';
export * from "./ndebit.js";
export { SimplePool, getPublicKey, nip19, generateSecretKey };
//# sourceMappingURL=index.js.map